import React from 'react';

import {SectionHeader} from 'presentation/pages/public/styles';
import {useMediaQueries} from 'presentation/pages/private';
import {ProductLogo} from 'presentation/components';
import {useHostName} from 'presentation/hooks';

export function Header() {
	const {isTablet, isMobile} = useMediaQueries();
	const {isGndiSaoPaulo, isClinipam, isNotredameSaude} = useHostName();
	const isGndiOrClinipam = isGndiSaoPaulo || isClinipam || isNotredameSaude;

	const customLogoHeaderHeight = () => {
		if (isClinipam) return isTablet ? 42 : 53;
		if (isGndiSaoPaulo || isNotredameSaude) return isTablet ? 40 : 50;
		return 32;
	};

	return (
		<SectionHeader $padding={isGndiOrClinipam ? '16px' : undefined}>
			<ProductLogo
				customHeight={customLogoHeaderHeight()}
				invertColor={isTablet}
				isMobile={isMobile}
			/>
		</SectionHeader>
	);
}
